import { render, staticRenderFns } from "./AuthProvider.vue?vue&type=template&id=2196c7c0"
import script from "./AuthProvider.vue?vue&type=script&lang=js"
export * from "./AuthProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports